var React = require('react');

function ExternalLinkAlt (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M400 320h32a16 16 0 0 1 16 16v128a48 48 0 0 1-48 48H48a48 48 0 0 1-48-48V112a48 48 0 0 1 48-48h160a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H64v320h320V336a16 16 0 0 1 16-16z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M512 24v128c0 21.47-26 32-41 17l-35.71-35.71L191.8 376.77a24 24 0 0 1-33.94 0l-22.63-22.63a24 24 0 0 1 0-33.94L378.76 76.68 343.05 41C328 25.9 338.66 0 360 0h128a24 24 0 0 1 24 24z","className":"fa-primary","key":2})]);
}

ExternalLinkAlt.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = ExternalLinkAlt;

ExternalLinkAlt.default = ExternalLinkAlt;
